<div class="m-preview__link" *ngIf="preview">
    <img class="m-cover" [src]="preview.cover" *ngIf="preview.cover">
    <div class="m-preview__content">
        <p class="m-preview__site">{{ link }}</p>
        <p [attr.class]="'m-preview__title m-link ' + class" (click)="navigate()">{{ preview.title }}</p>
        <p class="m-preview__summary">{{ preview.description }}</p>
    </div>
</div>
